import { createSlice } from '@reduxjs/toolkit';
import { getScheduledBatchParameters } from 'ducks/scheduled-batch-parameters/operators';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';
import { normalizeParameters } from 'ducks/utils';

const initialState: ProjectParameters = [];

const scheduledBatchParametersSlice = createSlice({
  name: Slices.SCHEDULED_BATCH_PARAMETERS,
  initialState,
  reducers: {
    clearParameters: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledBatchParameters.pending, () => {
        return initialState;
      })
      .addCase(getScheduledBatchParameters.fulfilled, (_, { payload }) => {
        return normalizeParameters(payload);
      })
      .addCase(getScheduledBatchParameters.rejected, () => {
        return initialState;
      });
  },
});

export const { clearParameters } = scheduledBatchParametersSlice.actions;

export default scheduledBatchParametersSlice.reducer;
